import { PlatformEnum } from '@/settings/enum';
import { createSlice } from '@reduxjs/toolkit';
import { log } from 'mathjs';

export const platformSlice = createSlice({
  name: PlatformEnum.NAME,
  initialState: {
    // 当前位置-平台类型id ( 1:总平台 | 2:公司平台 | 3:项目平台  )
    [PlatformEnum.TYPE]: 1,
    // 总平台详情
    [PlatformEnum.SUBJECT]: '',
    // 公司平台详情
    [PlatformEnum.COMPANY]: '',
    // 项目平台详情
    [PlatformEnum.PROJECT]: '',
    // 平台实体id
    [PlatformEnum.Entity_ID]: 1,
    // 合同平台详情
    ["contract_info"]: '',
  },
  reducers: {
    getEntityInfo: (state) => {
      if (state[PlatformEnum.TYPE] === 2) {
      }
      // type LimitedPlatformEnum = PlatformEnum.SUBJECT | PlatformEnum.COMPANY | PlatformEnum.PROJECT;
      //
      // const key: LimitedPlatformEnum = platformKeys.get(
      //   state[PlatformEnum.TYPE],
      // )!;
      // return {
      //   id: state[key],
      // };
    },
    setCompanyInfo: (state, { payload }: { payload: any }) => {
      state[PlatformEnum.TYPE] = 2;
      state[PlatformEnum.COMPANY] = payload;
      state[PlatformEnum.Entity_ID] = payload.id;
    },
    setProjectInfo: (state, { payload }: { payload: any }) => {
      state[PlatformEnum.TYPE] = 3;
      state[PlatformEnum.PROJECT] = payload;
      state[PlatformEnum.Entity_ID] = payload.id;

      console.log('setProjectInfo', payload);
    },

    setContractInfo: (state, { payload }: { payload: any }) => {
      state["contract_info"] = payload;
      console.log('setProjectInfo', payload);
    },

    removePlatformAll: (state) => {
      state[PlatformEnum.TYPE] = 1;
      state[PlatformEnum.COMPANY] = '';
      state[PlatformEnum.PROJECT] = '';
      state[PlatformEnum.Entity_ID] = 1;
    },
    removePlatformProject: (state, { payload }) => {
      state[PlatformEnum.TYPE] = 2;
      state[PlatformEnum.PROJECT] = '';
      state[PlatformEnum.Entity_ID] = payload;
    },
  },
});

// 每个 case reducer 函数会生成对应的 Action creators
export const { } = platformSlice.actions;

export default platformSlice.reducer;
